const poems = [
  // require('./Nora_Claire_Miller_1'),
  // require('./Nora_Claire_Miller_2'),
  // require('./Nora_Claire_Miller_3'),
  require('./Chessy_Normile'),  
  require('./Nick_Flynn'),  
  require('./Keetje_Kuipers'),
  require('./Kelly_Schirmann'),
  require('./Annelyse_Gelman'),
  require('./Franny_Choi'),
  require('./Jai_Hamid_Bashir'),
  require('./Matt_Nelson'),
  require('./KB'),
  require('./Eddie_Kim'),
  require('./Lily_Yanagimoto'),
  require('./Joshua_Nguyen'),
  require('./torrin_a._greathouse'),
  require('./Sadie_Dupuis'),
  require('./Jared_Harél'),
  require('./Sean_Singer'),
  require('./Golden'),
  require('./Noah_Falck'),
  require('./Forrest_Gander'),
  require('./Ben_Fama'),
  require('./Daniel_Borzutzky'),
  require('./Mónica_de_la_Torre'),
  require('./Michael_Pisaro-Liu'),
  require('./Matt_Mitchell'),
  require('./Xan_Forest_Phillips'),
  require('./Eleni_Sikelianos'),
  require('./Jos_Charles'),
  require('./Imani_Elizabeth_Jackson'),
  require('./Dan_Beachy-Quick'),
  require('./Rosebud_Ben-Oni'),
  require('./Gabrielle_Bates'),
  require('./Zachary_Schomburg_2'),
  require('./Anis_Mojgani'),
  require('./Eleanor_Eli_Moss'),
  require('./Hedgie_Choi'),
  require('./Jackson_Holbert_2'),
  require('./Dara_Wier'),
  require('./Aja_Moore'),
  require('./manuel_arturo_abreu'),
  require('./Woosung_Sohn'),
  require('./Zachary_Schomburg_1'),
  require('./Jackson_Holbert_1'),
  require('./Jenny_Qi'),
  require('./Veronica_Martin'),
  require('./Jose_Hernandez_Diaz'),
  require('./Max_Seifert'),
  require('./Madeleine_Mori'),
  require('./Mia_You'),
  require('./Sarah_Matthes'),
  // require('./Annelyse_Gelman'),
]

export default poems
